var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-calendar",
    d: "M22,9.556V8.889A2.892,2.892,0,0,0,19.111,6H8.889A2.892,2.892,0,0,0,6,8.889v.667ZM6,10.889v8.222A2.892,2.892,0,0,0,8.889,22H19.111A2.892,2.892,0,0,0,22,19.111V10.889Zm4.222,8.444a1.111,1.111,0,1,1,1.111-1.111A1.111,1.111,0,0,1,10.222,19.333Zm0-4a1.111,1.111,0,1,1,1.111-1.111A1.111,1.111,0,0,1,10.222,15.333Zm3.778,4a1.111,1.111,0,1,1,1.111-1.111A1.111,1.111,0,0,1,14,19.333Zm0-4a1.111,1.111,0,1,1,1.111-1.111A1.111,1.111,0,0,1,14,15.333Zm3.778,0a1.111,1.111,0,1,1,1.111-1.111A1.111,1.111,0,0,1,17.778,15.333Z",
    transform: "translate(-6 -6)",
    fill: "#555b70"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/iconCalendar.d8748eff69b7ae5c41c70fff906019d8.svg";
export { ForwardRef as ReactComponent };